<div *ngIf="dashboardFilters.length > 0" class="dashboard-filters-container">
    <span class="d-flex" *ngFor="let filter of dashboardFilters; let i = index">
        <span class="dashboard-filter" [ngClass]="{'selected-dashboard-filter': i === selectedDashboardFilter}" (click)="handleDashboardFilterClick(i)">{{filter}}</span>
    </span>
</div>
<div class="d-flex flex-column h-100">
    <div class="d-inline-block" ngbDropdown #moveDashboardDropdown="ngbDropdown">
        <span class="d-none" ngbDropdownAnchor></span>
        <div class="p-3" ngbDropdownMenu>
            <input type="text" class="form-control" list="dashboardManagementMoveList"
                [(ngModel)]="moveDashboardDestination" />
            <datalist id="dashboardManagementMoveList">
                <option *ngFor="let group of dashboardService.dashboardGroups" [value]="group">
            </datalist>
            <div class="d-flex justify-content-end mt-2">
                <button type="button" class="btn btn-text mr-2" (click)="moveDashboardDropdown.close()">
                    <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
                </button>
                <button type="button" class="btn btn-primary" (click)="moveDashboards()"
                    [disabled]="isMoving || moveDashboardDestination.length < 1">
                    <span cvLocalizedText langSection="Left_Nav_Popup" langKey="Move_Button">Save</span>
                </button>
            </div>
        </div>
    </div>

    <ag-grid-angular #manageAvailableDashboardsGrid *ngIf="gridOptions !== null" 
        class="ag-theme-balham flex-fill" [ngClass]="{'mt-2 mb-4': dashboardFilters.length > 0}" [gridOptions]="gridOptions">
    </ag-grid-angular>
</div>

<ng-template #ownershipErrorModal let-modal>
    
    <div class="modal-body cxone-error-body">
        <div class="cxone-confirm-header">
            <svg class="icon-24 fill-error mr-2">
                <use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use>
            </svg>
            <h4 class="modal-title cxone-confirm-title" id="modal-title"  >Error taking ownership</h4>
            <button type="button" class="icon-btn modal-close" aria-label="Close" (click)="modalService.dismissAll()">
                <svg class="icon-12 fill-iconDefault">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>
            <p class="cxone-confirm-text">Another user took ownership of the dashboard.
                <br>
                (error 405)
            </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary cxone-btn modal-footer-btn" (click)="modalService.dismissAll()">Close</button>
    </div>
</ng-template>
